import { ApolloClient, ApolloLink } from '@apollo/client';
import { BatchHttpLink } from '@apollo/client/link/batch-http/index.js';
import { setContext } from '@apollo/client/link/context/index.js';
import { EnumRequestHeaderNames } from '@pendwa/common/@types/interfaces.js';
import { rootRoutes } from '@pendwa/common/core/rootRoutes/index.js';
import { isPrerendering } from '../../utils/isPrerendering.js';
import { appStoreCredentials } from '../appStore/credentials.js';
export const getApolloClient = (options) => {
    const authLink = setContext((_, { headers }) => {
        const access_token = appStoreCredentials.get('token');
        const profile_uuid = appStoreCredentials.get('profile-uuid');
        return {
            headers: {
                ...headers,
                ...(access_token
                    ? {
                        [EnumRequestHeaderNames.UserToken]: access_token,
                    }
                    : {}),
                ...(profile_uuid
                    ? {
                        [EnumRequestHeaderNames.ProfileUUID]: profile_uuid,
                    }
                    : {}),
            },
        };
    });
    const httpLink = new BatchHttpLink({
        uri: rootRoutes.api.graphql.main.get(),
        headers: {},
        batchMax: 30,
        batchInterval: 200,
    });
    return new ApolloClient({
        ssrMode: isPrerendering(),
        ssrForceFetchDelay: 100,
        link: ApolloLink.from([authLink, httpLink]),
        cache: options.cache,
        assumeImmutableResults: true,
        defaultOptions: {
            query: {
                errorPolicy: 'all',
            },
            mutate: {
                errorPolicy: 'all',
            },
            watchQuery: {
                errorPolicy: 'all',
            },
        },
    });
};
//# sourceMappingURL=index.js.map